import Accordion from '@klv/organisms/accordion';
import BulletedList from '@klv/organisms/bulleted-list';
import BulletedLists from '@klv/organisms/bulleted-lists';
import Cards from '@klv/organisms/cards';
import Chart from '@klv/organisms/chart';
import ContentCarousel from '@klv/organisms/content-carousel';
import FeaturesList from '@klv/organisms/features-list';
import FormsCta from '@klv/organisms/forms-cta';
import FullColumn from '@klv/organisms/full-column';
import Gallery from '@klv/organisms/gallery';
import Iframe from '@klv/atoms/iframe';
import KlaviyoFormOrganism from '@klv/organisms/klaviyo-form';
import Logos from '@klv/organisms/logos';
import MainCta from '@klv/organisms/main-cta';
import RelatedContent from '@klv/organisms/related-content';
import SocialProof from '@klv/organisms/social-proof';
import Stats from '@klv/organisms/stats';
import TestimonialsQuote from '@klv/organisms/testimonials-quote';
import TestimonialsTwoColumn from '@klv/organisms/testimonials-two-column';
import TextTagline from '@klv/organisms/text-tagline';
import TileList from '@klv/organisms/tile-list';
import TwoColumn from '@klv/organisms/two-column';
import TwoColumnSlider from '@klv/organisms/two-column-slider';
import Video from '@klv/organisms/video';

import type { ITab, ITabLayout } from './types';

const getComponent = (row: ITabLayout) => {
  if (row?.componentType === 'AccordionComponent' && row?.accordion)
    return <Accordion {...row.accordion} />;
  if (row?.componentType === 'BulletedListComponent' && row?.bulletedList)
    return <BulletedList {...row.bulletedList} />;
  if (row?.componentType === 'BulletedListsComponent' && row?.bulletedLists)
    return <BulletedLists {...row.bulletedLists} />;
  if (row?.componentType === 'CardsComponent' && row?.cards)
    return <Cards {...row.cards} />;
  if (row?.componentType === 'ChartComponent' && row?.charts)
    return <Chart { ...row.charts } />;
  if (row?.componentType === 'ContentCarouselComponent' && row?.contentCarousel)
    return <ContentCarousel {...row.contentCarousel} />;
  if (row?.componentType === 'FeaturesListComponent' && row?.featuresList)
    return <FeaturesList {...row.featuresList} />;
  if (row?.componentType === 'FormsCtaComponent' && row?.formsCta)
    return <FormsCta {...row.formsCta} />;
  if (row?.componentType === 'FullColumnComponent' && row?.fullColumn)
    return <FullColumn {...row.fullColumn} />;
  if (row?.componentType === 'GalleryComponent' && row?.gallery)
    return <Gallery {...row.gallery} />;
  if (row?.componentType === 'IframeComponent' && row?.iframe)
    return <Iframe {...row.iframe} />;
  if (row?.componentType === 'KlaviyoFormComponent' && row?.klaviyoForm)
    return <KlaviyoFormOrganism {...row.klaviyoForm} />;
  if (row?.componentType === 'LogosComponent' && row?.logosOrganism)
    return <Logos {...row.logosOrganism} />;
  if (row?.componentType === 'MainCtaComponent' && row?.mainCta)
    return <MainCta {...row.mainCta} />;
  if (row?.componentType === 'RelatedContentComponent' && row?.relatedContent)
    return <RelatedContent {...row.relatedContent} />;
  if (row?.componentType === 'SocialProofComponent' && row?.socialProof)
    return <SocialProof {...row.socialProof} />;
  if (row?.componentType === 'StatsComponent' && row?.stats)
    return <Stats {...row.stats} />;
  if (row?.componentType === 'TestimonialsQuoteComponent' && row?.testimonialsQuote)
    return <TestimonialsQuote {...row.testimonialsQuote} />;
  if (row?.componentType === 'TestimonialsTwoColumnComponent' && row?.testimonialsTwoColumn)
    return <TestimonialsTwoColumn {...row.testimonialsTwoColumn.testimonialsQuote} {...row.testimonialsTwoColumn} />;
  if (row?.componentType === 'TextTaglineComponent' && row?.textTagline)
    return <TextTagline {...row.textTagline} />;
  if (row?.componentType === 'TileListComponent' && row?.tileList)
    return <TileList {...row.tileList} />;
  if (row?.componentType === 'TwoColumnComponent' && row?.twoColumn)
    return <TwoColumn {...row.twoColumn} />;
  if (row?.componentType === 'TwoColumnSliderComponent' && row?.twoColumnSlider)
    return <TwoColumnSlider {...row.twoColumnSlider} />;
  if (row?.componentType === 'VideoComponent' && row?.video)
    return <Video {...row.video} />;

  return null;
};

export const TabbedComponentLoop = ({ components }: ITab) => (
  components?.map((row) => (
    <div key={JSON.stringify(row)}>
      {getComponent(row)}
    </div>
  ))
);
